import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ResponsiveCompactRendererComponent } from './responsive-compact-renderer.component';
import { TranslateModule } from '@ngx-translate/core';



@NgModule({
  declarations: [
    ResponsiveCompactRendererComponent
  ],
  exports: [
    ResponsiveCompactRendererComponent
  ],
  imports: [
    CommonModule,
    TranslateModule
  ]
})
export class ResponsiveCompactRendererModule { }
